// extracted by mini-css-extract-plugin
export default {"default":"SnapState__default-kHBGA","light":"SnapState__light-xt1xM","active":"SnapState__active-nEcFG","created":"SnapState__created-sDXrZ"};